export const addTestIdSuffix = (suffix: string, testId?: string): string | undefined => {
  return testId ? `${testId}-${suffix}` : undefined
}
